<h5 class="title mb-4 text-primary">{{'sessao_vii'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_41')}}</label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_41_{{item.id}}"
                            #mdc_41="ngModel" name="mdc_41" [(ngModel)]="mdcService.formData.mdc_41"
                            value="{{item.value}}">
                        <label class="custom-control-label" for="mdc_41_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-sm-6" *ngIf="mdcService.isVisible(['mdc_41_1_1'], mdcService.formData.mdc_41! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_41_1_1')}}</label>
            <div class="form-control-wrap">
                <input type="tel" class="form-control" #mdc_41_1_1="ngModel" name="mdc_41_1_1"
                    [(ngModel)]="mdcService.formData.mdc_41_1_1" placeholder="{{'opcional'|translate}}">
            </div>
        </div>
    </div>
    <div class="col-sm-6" *ngIf="mdcService.isVisible(['mdc_41_1_2'], mdcService.formData.mdc_41! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_41_1_2')}}</label>
            <div class="form-control-wrap">
                <input type="email" class="form-control" #mdc_41_1_2="ngModel" name="mdc_41_1_2"
                    [(ngModel)]="mdcService.formData.mdc_41_1_2" placeholder="{{'opcional'|translate}}">
            </div>
        </div>
    </div>
    <div class="col-sm-12" *ngIf="mdcService.isVisible(['mdc_41_1_3'], mdcService.formData.mdc_41! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_41_1_3')}}</label>
            <div class="form-control-wrap">
                <input type="text" class="form-control" #mdc_41_1_3="ngModel" name="mdc_41_1_3"
                    [(ngModel)]="mdcService.formData.mdc_41_1_3" placeholder="{{'opcional'|translate}}">
            </div>
        </div>
    </div>
</div>